import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { WINDOW_LOCATION, type WindowLocation } from '@cloudsuite/mosaic-shared/scripts/window-location.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { html, LitElement } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'

export class UpdateProductConfigurationEvent extends Event {
  static type = 'request-update-product-configuration-event' as const
  basketLineId: number

  constructor(basketLineId: number) {
    super(UpdateProductConfigurationEvent.type, { bubbles: true, composed: true })
    this.basketLineId = basketLineId
  }
}
export class UpdateProductConfigurationEventFinished extends Event {
  static type = 'request-update-product-configuration-event-finished' as const

  constructor() {
    super(UpdateProductConfigurationEventFinished.type, { bubbles: true, composed: true })
  }
}


@customElement('csc-composable-weight-calculator-update-button')
export class CSCComposableWeightCalculatorUpdateButton extends LitElement {
  @property({ attribute: 'basket-line-id', type: Number })
  basketLineId?: number

  @inject(WINDOW_LOCATION)
  location!: WindowLocation

  @state()
  public isLoading = false

  private handleClick = () => {
    if (!this.basketLineId) return

    this.isLoading = true
    this.dispatchEvent(new UpdateProductConfigurationEvent(this.basketLineId))
  }

  private handleUpdateFinished = () => {
    this.isLoading = false
    this.location.reload()
  }

  override connectedCallback(): void {
    super.connectedCallback()
    document.addEventListener(UpdateProductConfigurationEventFinished.type, this.handleUpdateFinished)
  }

  override disconnectedCallback(): void {
    super.disconnectedCallback()
    document.removeEventListener(UpdateProductConfigurationEventFinished.type, this.handleUpdateFinished)
  }

  override render() {
    return html`<cse-button variant="secondary" fit="fill" @click="${this.handleClick}">
      ${this.isLoading ? html`
        <cse-loader slot="prefix" animate></cse-loader>  
      ` : html`
        ${t('update_configuration', { ns: 'csc-composable-weight-calculator-update-button', default: 'Update' })}
      `}
    </cse-button>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-composable-weight-calculator-update-button': CSCComposableWeightCalculatorUpdateButton
  }

  interface GlobalEventHandlersEventMap {
    [UpdateProductConfigurationEvent.type]: UpdateProductConfigurationEvent
    [UpdateProductConfigurationEventFinished.type]: UpdateProductConfigurationEventFinished
  }
}
